import { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

interface InputAutocompleteArrayRequiredProps {
  id: string;
  label: string;
  onInput: (id: string, value: string, isValid: boolean, label: string) => void;
  helperText: string;
  options: string[];
  initialValue?: string;
  variant?: "standard" | "filled" | "outlined";
  forceError?: boolean;
  disabled?: boolean;
  reinitialize?: boolean;
  updateInitValue?: boolean;
  notRequired?: boolean;
  style?: {};
}

export const InputAutocompleteArrayRequired = (
  props: InputAutocompleteArrayRequiredProps
) => {
  const {
    id,
    label,
    onInput,
    options,
    initialValue,
    forceError,
    variant,
    disabled,
    reinitialize,
    helperText,
    notRequired = false,
    style,
  } = props;
  const [inputValue, setInputValue] = useState<string>(initialValue || null);
  const [value, setValue] = useState<string>(initialValue || null);
  const [isTouched, setIsTouched] = useState<boolean>(false);

  useEffect(() => {
    onInput(
      id,
      inputValue,
      notRequired ? true : !!inputValue,
      label.charAt(0).toUpperCase() + label.slice(1)
    );
  }, [id, inputValue, label, onInput]);

  useEffect(() => {
    if (reinitialize) {
      onInput(
        id,
        initialValue,
        notRequired ? true : !!inputValue,
        label.charAt(0).toUpperCase() + label.slice(1)
      );

      setIsTouched(false);
      setInputValue(initialValue);
      setValue(initialValue);
    }
  }, [reinitialize, setIsTouched, setInputValue, setValue, initialValue]);

  const touchHandler = () => {
    setIsTouched(true);
  };

  return (
    <Autocomplete
      style={style}
      autoComplete
      disabled={disabled}
      id={id}
      options={options}
      onBlur={touchHandler}
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant={variant}
          error={(!inputValue && isTouched && !notRequired) || forceError}
          helperText={
            forceError ? helperText : !inputValue && isTouched && helperText
          }
          label={label.charAt(0).toUpperCase() + label.slice(1)}
        />
      )}
    />
  );
};
